import { useTranslation } from 'react-i18next';
import { InvitedStatusWrapper, NotInvitedStatusWrapper } from './styles';

export enum FlexflowEmployeeStatusesBeforeActivation {
  INVITED = 'invited',
  NOT_INVITED = 'not_invited',
  PENGING_AUTH = 'pending_swan_oauth',
  ACCOUNT_BINDED = 'account_binded',
  ACCEPTED = 'accepted'
}

type ContractStatusProps = {
  flexflowStatus: string;
};

const StatusTag = {
  [FlexflowEmployeeStatusesBeforeActivation.NOT_INVITED]: NotInvitedStatusWrapper,
  [FlexflowEmployeeStatusesBeforeActivation.INVITED]: InvitedStatusWrapper,
  [FlexflowEmployeeStatusesBeforeActivation.ACCEPTED]: InvitedStatusWrapper,
  [FlexflowEmployeeStatusesBeforeActivation.PENGING_AUTH]: '',
  [FlexflowEmployeeStatusesBeforeActivation.ACCOUNT_BINDED]: ''
};

const ContractStatusBeforeInvitation = ({ flexflowStatus }: ContractStatusProps) => {
  const { t } = useTranslation(['flexflow']);
  const StatusWrapperTag = flexflowStatus && StatusTag[flexflowStatus as FlexflowEmployeeStatusesBeforeActivation];
  let status = flexflowStatus;

  // Employees who previously accepted the invitation but have a terminated card will be displayed as already invited
  if (flexflowStatus === FlexflowEmployeeStatusesBeforeActivation.ACCEPTED) {
    status = FlexflowEmployeeStatusesBeforeActivation.INVITED;
  }

  if (!flexflowStatus || !StatusWrapperTag) {
    return <></>;
  }

  return <StatusWrapperTag>{t(`employee status.${status}`, { ns: 'flexflow' })}</StatusWrapperTag>;
};

export default ContractStatusBeforeInvitation;
